export var createRoutingRulesApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl, "/routing-rules");
    return {
        get: function (dto) { return http.get("".concat(apiUrl, "/").concat(dto.id), dto); },
        getAll: function () { return http.get(apiUrl); },
        getByTargetGroupIds: function (dto) { return http.post("".concat(apiUrl, "/groups"), dto); },
        reorderRules: function (dto) { return http.put(apiUrl, dto); },
        updateRule: function (dto) { return http.put("".concat(apiUrl, "/").concat(dto.id), dto); },
        addRule: function (dto) { return http.post(apiUrl, dto); },
        deleteRule: function (dto) { return http.delete("".concat(apiUrl, "/").concat(dto.id), dto); },
    };
};
//# sourceMappingURL=index.js.map